export default function Footer() {
  return (
    <footer
      data-testid="global-footer"
      className="w-full border-t border-gold/10 py-6 mt-16 text-center"
    >
      <p className="text-xs tracking-[0.28em] uppercase text-neutral-500">
        Potenciado por{" "}
        <span className="text-gold font-semibold">Grupo Disfruta PaRaMa</span>
      </p>
    </footer>
  );
}
